import { Component, EventEmitter, Input, Output, ChangeDetectorRef } from '@angular/core';
import { SmartEmployeeOverviewFilterTooltips } from '../../constants-and-enums/smart-employee-overview-types';

export interface CategoryFilterTab {
    key?: string;
    label?: string;
    count?: number;
}

@Component({
    standalone: false,
    selector: 'app-category-filter-tabs',
    templateUrl: './category-filter-tabs.component.html',
    styleUrls: ['./category-filter-tabs.component.scss']
})
export class CategoryFilterTabsComponent {
    @Input() tabs: CategoryFilterTab[] = [];
    @Input() hasTooltip = false;
    @Input() selectedKey: string;
    @Output() tabClick = new EventEmitter<string>();

    tooltipTimer: any;
    showTooltip: { [key: string]: boolean } = {};

    constructor(private changeDetector: ChangeDetectorRef) {}

    handleClick(tab: CategoryFilterTab) {
        this.tabClick.emit(tab?.key);
    }

    getTooltipText(key: string): string {
        return SmartEmployeeOverviewFilterTooltips[key];
    }

    startTooltipTimer(key: string) {
        this.tooltipTimer = setTimeout(() => {
            this.showTooltip[key] = true;
            this.changeDetector.detectChanges();
        }, 500);
    }

    cancelTooltipTimer(key: string) {
        clearTimeout(this.tooltipTimer);
        this.showTooltip[key] = false;
        this.changeDetector.detectChanges();
    }
}
